import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from '../../../local-storage.service'
import { ServiceProvider } from '../../../../core/service/service.provider';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-menu-bar',
  templateUrl: './side-menu-bar.component.html',
  styleUrls: ['./side-menu-bar.component.scss']
})

export class SideMenuBarComponent implements OnInit {
    @Output() eve: EventEmitter<object> = new EventEmitter<object>(); 
    sideMenuMinstatus = false;
    isSelectedMenu;
    public innerWidth: any;
    isOpen:boolean;
    activeParentRoute;
    @Input() sideMenuMinstatusForMain;
    @Output() triggerSidemenuMinStatus = new EventEmitter();
    display_menus;

    menus_config = {
      "Dashboard" : {route: '/dashboard', icon: "fa fa-tachometer"},
      "Setup" : {route: '/setup', icon: "fa fa-cogs"},
      "Roles" : {route: '/setup/roles', icon: "fa fa-user-circle-o"},
      "Users" : {route: '/setup/users', icon: "fa fa-users"},
      "Locations" : {route: '/setup/locations', icon: "fa fa-map-marker"},
      "Mapping" : {route: '/setup/mapping', icon: "fa fa-snowflake-o"},
      "Device Type" : {route: '/setup/device-type', icon: "fa  fa-microchip"},
      "Inventory" : {route: '/inventory', icon: "fa fa-th-list"},
      "Vendors" : {route: '/inventory/vendors', icon: "fa fa-truck"},
      "Customers" : {route: '/inventory/customers', icon: "fa fa-user-circle-o"},
      "Devices" : {route: '/inventory/devices', icon: "fa fa-desktop"},
      "Monitoring" : {route: '/monitoring', icon: "fa fa-television"},
      "History" : {route: '/history', icon: "fa fa-file-text"},
      "Device" : {route: '/history/device', icon: "fa fa-desktop"},
      "Process" : {route: '/history/process', icon: "fa fa-history"},
    }
  constructor(private storage:LocalStorageService, public dataService: ServiceProvider, public router:Router) { }

  ngOnInit() {
    this.storage.watchStorage().subscribe((data:string) => {
      if(data == 'isRoleChange'){
        this.storage.removeData(data)
        this.arrangeMenus(this.storage.getData("userData")['role_data']['menus_enabled'])
      }
    })

    let roue_url = this.router.url.split('/')[1]
    this.isSelectedMenu = roue_url[0].toUpperCase() + roue_url.slice(1)


  }

  arrangeMenus(menuList){
    let found_all_menu = menuList.find(menu => menu.menu_name == "ALL")
    if(found_all_menu){
      this.dataService.get('GetMasterMenuList')
      .subscribe((values) => {
        this.display_menus = values
        this.display_menus.shift()
      });
    }else{
      this.display_menus = menuList
    }
  }
  
    toggleSideMenu(): void {
      this.sideMenuMinstatus = !this.sideMenuMinstatus;
      this.triggerSidemenuMinStatus.emit(this.sideMenuMinstatus);
    }
    toggleResSideMenu(screenWidth): void {
      this.sideMenuMinstatus = true;
      this.triggerSidemenuMinStatus.emit(this.sideMenuMinstatus);
    }
    

    toggled(event, menuName) {
      this.isSelectedMenu = ''
      // if(menuName == this.isSelectedMenu){
      //   event.stopPropagation();
      // }else{
        this.isSelectedMenu = menuName;
        let roue_url = this.router.url.split('/')[1]
        this.activeParentRoute = roue_url[0].toUpperCase() + roue_url.slice(1)
        
        
      // }
      
        // if (event) {
        //     this.isOpen = !this.isOpen;
        // } else {
        //     return this.isOpen;
        // }
      //  let element = document.getElementById('platformMenu');
      //   element.className = 'show'
      
        console.log('is open', this.isOpen);
    }

    checkParentRoute(){
      let roue_url = this.router.url.split('/')[1]
        this.activeParentRoute = roue_url[0].toUpperCase() + roue_url.slice(1)
    }
}
